<template>
  <v-container>
    <div id="grid-relator">
      <v-layout
        style="text-align: right"
        v-if="
          usuarioLoggedTipe == 'PROVEEDOR' ||
          usuarioLoggedTipe == 'ADMINISTRADOR'
        "
      >
        <v-flex xs12>
          <v-btn color="primary" @click="nuevaSesion()"
            >Ingresar Programa</v-btn
          >
        </v-flex>
      </v-layout>
      <v-toolbar card color="white">
        <v-toolbar-title class="indigo--text"
          >Sesiones Formativas</v-toolbar-title
        >
      </v-toolbar>

      <!--  dsoto 18-11-2022 -->
      <v-layout justify-center>
        <v-flex xs12 md6>
          <v-text-field
            onkeydown="return event.key != 'Enter';"
            action="."
            method="get"
            v-model="search"
            append-icon="search"
            label="Digite nombre producto o palabra clave"
            single-line
            hide-details
            @input="getDataFull()"
          ></v-text-field>
        </v-flex>
      </v-layout>
      <!--   dsoto 18-11-2022  -->

      <v-layout justify-center>
        <v-flex lg12>
          <div v-if="loading">
            <loading></loading>
          </div>
          <div v-if="alerta">
            <alert-empty></alert-empty>
          </div>
          <v-spacer></v-spacer>
          <v-data-table
            :headers="headers"
            :items="datosPaginados"
            :search="search"
            :page.sync="page"
            :rows-per-page-items="rowsPerPageItems"
            class="elevation-1"
            @page-count="pageCount = $event"
            hide-actions
          >
            <template v-slot:items="props">
              <td>{{ props.item.region }}</td>
              <td class="text-xs-left">{{ props.item.comuna }}</td>
              <td class="text-xs-left">{{ props.item.nombreSede }}</td>
              <td>{{ props.item.salaCapacitacion }}</td>
              <td class="text-xs-left">{{ props.item.fechaCapacitacion }}</td>
              <td>
                <v-btn
                  depressed
                  outline
                  icon
                  fab
                  dark
                  color="green darken-4"
                  small
                  title="Ver Sesión"
                  @click="sesionDetalle(props.item.id)"
                >
                  <v-icon>remove_red_eye</v-icon>
                </v-btn>
                <v-btn
                  v-if="props.item.estadoSesion != 2"
                  depressed
                  outline
                  icon
                  fab
                  dark
                  color="primary"
                  small
                  title="Editar Sesion"
                  @click="editarSesion(props.item.id)"
                >
                  <v-icon>open_in_new</v-icon>
                </v-btn>
                <v-btn
                  v-if="props.item.estadoSesion != 2 && getCodigoPerfil() != 'LEC' && !isContratoCerrado()"
                  depressed
                  outline
                  icon
                  fab
                  dark
                  color="error"
                  small
                  title="Anular Sesión"
                  @click="anularSesion(props.item.id)"
                >
                  <v-icon>clear</v-icon>
                </v-btn>
              </td>
            </template>
          </v-data-table>

          <!--  dsoto 18-11-2022 -->
          <v-flex xs12 sm6>
            <v-text-field
              value=""
              label="Total de Registros"
              v-model="cantRegistros"
              disabled
            ></v-text-field>
          </v-flex>
          <!--  dsoto 18-11-2022 -->

          <!--  dsoto 18-11-2022 -->
          <div class="text-center pt-2">
            <v-pagination
              @input="changePage(page)"
              v-model="page"
              :length="pageCount"
              :total-visible="9"
              circle
            >
            </v-pagination>
          </div>
          <!-- dsoto 18-11-2022  paginacion  -->

          <v-card-actions class="pb-3">
            <v-spacer></v-spacer>
            <v-btn
              class="btn-sigas"
              depressed
              outline
              icon
              fab
              dark
              color="green darken-4"
              small
            >
              <v-icon>remove_red_eye</v-icon> </v-btn
            >Ver Detalles Sesión Formativa
            <v-flex
              v-if="(usuarioLoggedTipe == 'PROVEEDOR') && getCodigoPerfil() != 'LEC' && !isContratoCerrado()"
            >
              <v-btn
                class="btn-sigas"
                depressed
                outline
                icon
                fab
                dark
                color="primary"
                small
              >
                <v-icon>open_in_new</v-icon> </v-btn
              >Editar Sesión Formativa
              <v-btn v-if="(usuarioLoggedTipe == 'AGENCIA' || usuarioLoggedTipe == 'ADMINISTRADOR') && getCodigoPerfil() != 'LEC' && !isContratoCerrado()"
                class="btn-sigas"
                depressed
                outline
                icon
                fab
                dark
                color="error"
                small
              >
                <v-icon>clear</v-icon> </v-btn
              >Anular Sesión
            </v-flex>
          </v-card-actions>
        </v-flex>
      </v-layout>

      <v-flex>
        <v-btn color="primary" @click="descargaMasiva()">Descarga masiva</v-btn>
      </v-flex>
      <v-dialog v-model="dialogLoading" persistent max-width="390">
        <loading-descarga></loading-descarga>
      </v-dialog>
    </div>
    <v-dialog v-model="dialog" max-width="500">
      <v-form ref="form" v-model="validacion" lazy-validation>
        <v-card>
          <v-card-title class="headline" style="font-weight: bold"
            >Complete los datos para anular el programa de
            formación</v-card-title
          >
          <v-layout justify-center>
            <v-flex xs8>
              <v-menu
                v-model="menu1"
                :close-on-content-click="false"
                :nudge-right="40"
                lazy
                transition="scale-transition"
                offset-y
                full-width
                min-width="290px"
              >
                <template v-slot:activator="{ on }">
                  <v-text-field
                    v-model="fechaAnulacion"
                    label="Fecha Anulacion"
                    prepend-icon="event"
                    v-on="on"
                  ></v-text-field>
                </template>
                <v-date-picker
                  v-model="fechaAnulacion"
                  no-title
                  @input="menu1 = false"
                  locale="es"
                  first-day-of-week="1"
                ></v-date-picker>
              </v-menu>
              <v-textarea
                v-model="observaciones"
                solo
                name="input-7-4"
                label="Observaciones de anulación."
              ></v-textarea>
              <v-btn v-if="getCodigoPerfil() != 'LEC' && !isContratoCerrado()"
                color="primary"
                dark
                :loading="loading"
                class="mb-2"
                @click="anular()"
              >
                Anular
                <v-icon right dark>clear</v-icon>
              </v-btn>
              <v-btn color="primary" @click="dialog = false" class="mb-2"
                >Cancelar</v-btn
              >
            </v-flex>
          </v-layout>
          <v-card-actions>
            <v-spacer></v-spacer>
          </v-card-actions>
        </v-card>
      </v-form>
    </v-dialog>
  </v-container>
</template>
<script>
import axios from "axios";
import DataAdjunto from "@/components/AdjuntoData.vue";
import Loading from "@/views/ui/Loading.vue";
import AlertEmpty from "@/views/ui/AlertEmpty.vue";
import LoadingDescarga from "@/views/ui/LoadingDescarga.vue";
import jwtDecode from "jwt-decode";

export default {
  name: "grid-relator",

  components: {
    DataAdjunto,
    LoadingDescarga,
    Loading,
    AlertEmpty,
  },
  props: {
    rowsTable: String,
    tipeView: String,
  },

  data() {
    return {
      idSesion: "",
      dialogLoading: false,
      fechaAnulacion: "",
      observaciones: "",
      loading: false,
      dialog: false,
      alerta: false,
      rowsPerPageItems: [20],
      pagination: {
        rowsPerPage: 20,
      },
      idContrato: "",
      headers: [
        { text: "Región", align: "left", sortable: false, value: "region" },
        { text: "Comuna", sortable: false, value: "comuna" },
        {
          text: "Nombre de la Sede",
          sortable: false,
          value: "nombreSede",
        },
        {
          text: "Sala de Capacitación",
          sortable: false,
          value: "salaCapacitacion",
        },
        {
          text: "Fecha Capacitacion",
          sortable: false,
          value: "fechaCapacitacion",
        },
        {
          text: "Accion",
          sortable: false,
          value: "",
        },
      ],
      itemsDocumento: [],
      // dsoto 18-11-2022
      search: "",
      page: 1,
      pageCount: 0,
      datosPaginados: [],
      paginaActual: 1,
      cantRegistros: 0,
    };
  },
  watch: {
    dialogLoading(val) {
      if (!val) return;

      setTimeout(() => (this.dialogLoading = false), 4000);
    },
  },
  created() {
    this.idContrato = this.$store.getters.contratoStored;
    this.proceso = this.$store.getters.proSelectedStored;
    this.usuarioLoggedTipe = this.$store.getters.userLogged.tipo;
    this.loadData();
  },

  mounted() {},
  computed: {},
  methods: {
    getCodigoPerfil() {
      const token = localStorage.getItem("token");
      const decoded = jwtDecode(token);
      const user = decoded.dto;
      // console.log("DEVODED USER:", user);
      return user.perfil.codigo;
    },
    isContratoCerrado() {
      const contratoCerradoConId = JSON.parse(localStorage.getItem("contratoCerradoConId"));
      if (contratoCerradoConId && contratoCerradoConId.idContrato === this.idContrato) {
        return contratoCerradoConId.cerrado;
      }
      return false;
    },
    anularSesion(id) {
      this.dialog = true;
      this.idSesion = id;
    },

    async loadSesionesFormativas() {
      return await axios
        .get("/sesionesFormativas/" + this.idContrato)
        .then(function (response) {
          return response.data;
        })
        .catch((error) => {
          if (error) {
            console.log(error.response.data);
          }
          return [];
        });
    },
    async loadData() {
      this.loading = true;
      this.cantRegistros = 0; // dsoto 18-11-2022
      this.itemsDocumento = await this.loadSesionesFormativas();
      if (this.itemsDocumento.length > 0) {
        this.cantRegistros = this.itemsDocumento.length; // dsoto 18-11-2022
        this.pageCount = Math.ceil(
          this.itemsDocumento.length / this.rowsPerPageItems
        ); // dsoto 18-11-2022
        this.getDataPagina(this.page); // dsoto 18-11-2022

        this.alerta = false;
      } else {
        this.alerta = true;
      }
      this.loading = false;
    },
    descargaMasiva() {
      this.dialogLoading = true;
      let that = this;
      this.body = {
        idContrato: this.idContrato,
      };
      axios
        .post("/sesionFormativa/downloadExcel", this.body, {
          responseType: "blob",
        })
        .then(function (response) {
          const urle = window.URL.createObjectURL(response.data);
          const link = document.createElement("a");
          link.href = urle;
          link.setAttribute("download", "DESCARGA_SESIONES_FORMATIVAS.xlsx");
          document.body.appendChild(link);
          link.click();
          return response.data;
        })
        .catch(function (error) {
          console.log(error);
        });
    },
    anular() {
      this.loading = true;
      let idContrato = this.$store.getters.contratoStored;

      this.body = {
        id: this.idSesion,
        idContrato: idContrato,
        estadoSesion: 2,
        observaciones: this.observaciones,
        fechaObservaciones: this.formatoFecha(this.fechaAnulacion),
      };
      axios
        .put("/sesionFormativa/anular", this.body)
        .then((response) => {
          this.resp = response.data;
          window.getApp.$emit("APP_SAVE");
          this.loading = false;
          this.loadData();
          this.dialog = false;
        })
        .catch(function (error) {
          window.getApp.$emit("ERROR_EXCEPTION", error.response.data.message);
          this.loading = false;
          this.loadData();
          this.dialog = true;
        });
    },

    // dsoto 18-11-2022
    changePage(page) {
      this.page = page <= 0 || page > this.pages ? this.page : page;
      this.getDataPagina(this.page);
    },

    getDataPagina(noPagina) {
      this.paginaActual = noPagina;
      this.datosPaginados = [];

      let ini = noPagina * this.rowsPerPageItems - this.rowsPerPageItems;
      let fin = noPagina * this.rowsPerPageItems;
      this.datosPaginados = this.itemsDocumento.slice(ini, fin);
    },
    getDataFull() {
      this.datosPaginados = [];
      this.page = 1;
      console.log(this.search);

      if (this.search.length > 0) {
        this.datosPaginados = this.itemsDocumento.slice(
          0,
          this.itemsDocumento.length
        );
      } else {
        this.getDataPagina(this.page);
      }
    },
    // dsoto 18-11-2022

    reload() {
      setTimeout(() => {
        this.$parent.reloadDocumento();
      }, 1000);
    },
    nuevaSesion() {
      this.loading = true;
      setTimeout(() => {
        this.$router.push({
          name: "SesionesFormativaRegistra",
          params: { tipeView: "crear" },
        });
      }, 1000);
    },
    editarSesion(id) {
      this.loading = true;
      setTimeout(() => {
        this.$router.push({
          name: "SesionesFormativaRegistra",
          params: { id: id, tipeView: "modifica" },
        });
      }, 1000);
    },
    sesionDetalle(id) {
      this.loading = true;
      setTimeout(() => {
        this.$router.push({
          name: "SesionesFormativaRegistra",
          params: { id: id, tipeView: "consulta" },
        });
      }, 1000);
    },
    formatoFecha(f) {
      return f.replace(/^(\d{4})-(\d{2})-(\d{2})$/g, "$3-$2-$1");
    },
  },
};
</script>